import { INFORMATION_CARD_GENERATOR } from 'services/infoCardGenerator/logging/constants';

// Used to filter/find chat-ui logs in DD
const API_RETRY_SUCCESSFUL = 'API call successful after retry attempt(s)';
const TWILIO_INIT_RETRY_SUCCESSFUL = 'Twilio initialization successful after retry attempt(s)';
const TWILIO_INIT_POLLING_SUCCESSFUL =
  'Twilio initialization successful after polling for connected status';
const CHAT_INITIALIZED = 'Chat application initialized';
const CHAT_INITIALIZE_BLANK_SCREEN = 'Initialize chat application after seeing blank screen';
const CONTEXT_URL_UPDATED_NO_RELOAD = 'Context updated on URL change without page reload';
const INACTIVITY_RECONNECT = 'Reconnect from inactivity';
const ENGINE_DELAYED_RESPONSE = 'Engine delayed response';
const MARKDOWN_LINK_CLICKED = 'Markdown link clicked';
const USER_MESSAGE_SENT = 'User Message Sent';
const HAND_RAISER_SHOWN = 'Hand Raiser Shown';
const HAND_RAISER_USER_CLICK = 'Hand Raiser Clicked by User';
const HAND_RAISER_CLOSED = 'Hand Raiser Closed';
const SCROLL_CONVO_BOTTOM_CTA_SHOWN = 'Scroll to conversation bottom CTA shown';
const SCROLL_CONVO_BOTTOM_CTA_CLICK = 'Scroll to conversation bottom CTA clicked';
const CHAT_BACKEND_MISMATCH_ERROR = 'Chat Backend Mismatch Error';
const RESYNC_MESSAGES_LIST = 'Re-sync messages list after timeout';
const DYNAMIC_HANDRAISER_NO_CONTENT = 'No content available for handraiser';
const HANDRAISER_MESSAGE_INTENT = 'Handraiser message intent sent';
const CHAT_UI_DEBUG_PANEL_SHOWN = 'Chat UI debug panel shown';
const CHAT_BE_COMMAND_INVOKED = 'Chat BE command invoked';
const CHAT_BE_COMMAND_COMPLETED = 'Chat BE command completed';
const CHAT_BE_COMMAND_FAILED = 'Chat BE command failed';
const VENDOR_COMMAND_FALLBACK_COMPLETED = 'Vendor command fallback completed';
const VENDOR_COMMAND_FALLBACK_FAILED = 'Vendor command fallback failed';

export const CUSTOM_ACTION_NAMES = {
  API_RETRY_SUCCESSFUL,
  TWILIO_INIT_RETRY_SUCCESSFUL,
  TWILIO_INIT_POLLING_SUCCESSFUL,
  CHAT_INITIALIZED,
  CHAT_INITIALIZE_BLANK_SCREEN,
  CHAT_UI_DEBUG_PANEL_SHOWN,
  CONTEXT_URL_UPDATED_NO_RELOAD,
  INACTIVITY_RECONNECT,
  ENGINE_DELAYED_RESPONSE,
  MARKDOWN_LINK_CLICKED,
  USER_MESSAGE_SENT,
  INFORMATION_CARD_GENERATOR,
  HAND_RAISER_SHOWN,
  HAND_RAISER_USER_CLICK,
  HAND_RAISER_CLOSED,
  SCROLL_CONVO_BOTTOM_CTA_SHOWN,
  SCROLL_CONVO_BOTTOM_CTA_CLICK,
  CHAT_BACKEND_MISMATCH_ERROR,
  RESYNC_MESSAGES_LIST,
  DYNAMIC_HANDRAISER_NO_CONTENT,
  HANDRAISER_MESSAGE_INTENT,
  CHAT_BE_COMMAND_INVOKED,
  CHAT_BE_COMMAND_COMPLETED,
  CHAT_BE_COMMAND_FAILED,
  VENDOR_COMMAND_FALLBACK_COMPLETED,
  VENDOR_COMMAND_FALLBACK_FAILED,
} as const;
